import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';

// Styles
import styles from './styles';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Card, { CardActions, CardContent } from 'material-ui/Card';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import IconButton from 'material-ui/IconButton';
import MenuIcon from 'material-ui-icons/Error';
import BackIcon from 'material-ui-icons/KeyboardBackspace';
import FindIcon from 'material-ui-icons/FindInPage';

// Components
import Title from './components/Title';
import QuestionMark from './components/QuestionMark';

class Header extends Component {
  render(){
    const { classes, theme, location } = this.props;

    var pathName = "Search"
    var backButton = ""

    if (window.location.pathname.includes("all_candidates")){
        pathName = "Search / All Candidates";

        if (window.location.pathname.includes("results")) {
          pathName = "Search / All Candidates / Results";
        }

        backButton = <IconButton color="contrast" aria-label="open drawer" onClick={() => {window.history.go(-1);}} className={classes.backIcon}><BackIcon /></IconButton>
    } else if  (window.location.pathname.includes("create_new_search")) {
        pathName = "Search / Create New Search";
        if (window.location.pathname.includes("six_basic_filters")){
          pathName = "Search / Create New Search / Basic Filters";

          if (window.location.pathname.includes("set_name")) {
            pathName = "Search / Create New Search / Basic Filters / Set Name";
          } else if (window.location.pathname.includes("results")) {
            pathName = "Search / Create New Search / Basic Filters / Results";
          } else if (window.location.pathname.includes("question1")) {
            pathName = "Search / Create New Search / 1. Distance";
          } else if (window.location.pathname.includes("question2")) {
            pathName = "Search / Create New Search / 2. Preferred OAR";
          } else if (window.location.pathname.includes("question3")) {
            pathName = "Search / Create New Search / 3. Profile AGE";
          } else if (window.location.pathname.includes("question4")) {
            pathName = "Search / Create New Search / 4. Oldest Preferred Age";
          } else if (window.location.pathname.includes("distribution_2")) {
            pathName = "Search / Create New Search / OAR Distribution";
          } else if (window.location.pathname.includes("distribution_3")) {
            pathName = "Search / Create New Search / AGE Distribution";
          } else if (window.location.pathname.includes("question5")) {
            pathName = "Search / Create New Search / 5. Education";
          } else if (window.location.pathname.includes("question6")) {
            pathName = "Search / Create New Search / 6. Income";
          } else if (window.location.pathname.includes("distribution_5")) {
            pathName = "Search / Create New Search / Education Distribution";
          } else if (window.location.pathname.includes("distribution_6")) {
            pathName = "Search / Create New Search / Income Distribution";
          }

        } else if (window.location.pathname.includes("concierge_filters")){
          pathName = "Search / Create New Search / Concierge Filters";
        } else if (window.location.pathname.includes("premium_displays")){
          pathName = "Search / Create New Search / Premium Displays";
        }

        backButton = <IconButton color="contrast" aria-label="open drawer" onClick={() => {window.history.go(-1);}} className={classes.backIcon}><BackIcon /></IconButton>
    } else if  (window.location.pathname.includes("search_by_name")) {
        pathName = "Search / Search By Candidate ID";
          backButton = <IconButton color="contrast" aria-label="open drawer" onClick={() => this.props.changeRoute("/console/search")} className={classes.backIcon}><BackIcon /></IconButton>
    } else if  (window.location.pathname.includes("saved_searches")) {
        pathName = "Search / Saved Searches";
        if (window.location.pathname.includes("filters")){

          pathName = "Search / Saved Searches / Sub Filter";

          let name = getParameterByName('name').split('?count')[0];
          if (name != null) {
            pathName = "Search / Saved Searches / Sub Filter / " + name;
          }


        } else if (window.location.pathname.includes("result")){
          pathName = "Search / Saved Searches / Result";
        }

        backButton = <IconButton color="contrast" aria-label="open drawer" onClick={() => {window.history.go(-1);}} className={classes.backIcon}><BackIcon /></IconButton>
    }

    if (window.location.pathname.includes("all_candidates") || window.location.href.includes("filters?name=All%20Candidates")) {
      return(
        <div className={classes.root}>
          <AppBar position="fixed" className={classes.appBar}>
            <Toolbar>
              {backButton}
              <Typography type="title" color="inherit" className={classes.flex}>
                {pathName}
              </Typography>
              <Typography type="body2" gutterBottom align="center" className={classes.flexTitleFilter}>
                Adhoc
              </Typography>
            </Toolbar>
          </AppBar>
          <IconButton
            color="contrast"
            aria-label="open drawer"
            onClick={() => {this.props.changeRoute("/console/display/adhoc_filters");}}
            className={classes.iconRightTop}
          >
            <FindIcon />
          </IconButton>
        </div>
      );
    } else {
      return(
        <div className={classes.root}>
          <AppBar position="fixed" className={classes.appBar}>
            <Toolbar>
              {backButton}
              <Typography type="title" color="inherit" className={classes.flex}>
                {pathName}
              </Typography>
            </Toolbar>
          </AppBar>
          <IconButton
            color="contrast"
            aria-label="open drawer"
            onClick={() => {this.props.changeRoute("/information/search");}}
            className={classes.iconRight}
          >
            <MenuIcon />
          </IconButton>
        </div>
      );
    }




  }
}

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
    };
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    changeRoute: (url) => dispatch(push(url)),
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps,mapDispatchToProps)(Header)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/components/Header/index.js